import axios from "axios";
import firebase from "firebase";
import {addToState, clearState} from "./stateController";

export function authorizeSpotify() {
    clearState()
    window.location = global.API_URL + "/authorize";
}

export function getSpotifyToken(code) {
    return new Promise((resolve, reject) => {
        axios.post(global.API_URL + "/token", {"code": code}).then(response => {
            if(code) {
                resolve(getAPIToken(response.data.access_token, response.data.refresh_token));
            }
            else {
                addToState({
                    access_token: response.data.access_token,
                    refresh_token: response.data.refresh_token
                })
                resolve();
            }
        }).catch(() => window.location = "/");
    });
}

function getAPIToken(accessToken, refreshToken) {
    const postData = {
        "accessToken": accessToken,
        "refreshToken": refreshToken
    }

    axios.post(global.API_URL + "/login", postData).then(response => {
        addToState({
            access_token: accessToken,
            refresh_token: refreshToken
        })
        loginWithToken(response.data);
    }).catch(error => {
        console.log(error);
        window.location = "/";
    });
}

function loginWithToken(token) {
    return new Promise((resolve, reject) => {
        firebase.auth().signInWithCustomToken(token).then((userCredential) => {
            resolve(getUser());
        }).catch((error) => {
            reject(error);
        });
    })
}

function getUser() {
    return new Promise((resolve, reject) => {
        firebase.auth().currentUser.getIdToken( true).then(function(idToken) {
            axios.get(global.API_URL + "/user", {params: {token: idToken}}).then((response) => {
                addToState({apiToken: idToken})
                addToState(response.data)
                window.location = "/dashboard";
                resolve();
            }).catch(error => {
                reject(error);
            });
        }).catch(error => reject(error));
    });
}

export function joinRoom(code, username) {
    return new Promise(function(resolve, reject) {
        getSpotifyToken(null).then(() => {
            axios.post(global.API_URL + "/join-room", {
                "code": code,
                "username": username
            }).then(token => resolve(loginWithToken(token.data)))
            .catch(error => reject(error));
        });
    });
}
